<div class="subBlockContent" id="addaddon">
  <child-header [title]="title" (closeEvent)="close()"></child-header>
  <div class="inner-subBlock-wrapper">
    <!-- <div class="page-title-wrapper">
      <div class="title blade-title-font">
        {{title}}
      </div>
      <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
    </div> -->
    <div style="margin-bottom:20px" class="filter-wrapper">
        <div class="searchInputGroup">
          <div class="searchIcon">
            <img src="../images/new_ui/filter.png">
          </div>
          <input class="searchInput" type="text" #searchValue placeholder="Filter" [(ngModel)]="searchAddon"
            (ngModelChange)="filterAddon()">
        </div>
    </div>

    <loading-screen *ngIf="!loadContent" [showBlurTable]="true"
      (currentLoadingStatus)="onLoading($event)"></loading-screen>
    <div class="col-md-12 align-center" *ngIf="!addonList?.length && loadContent">
      <label class="noData-wrapper">
        We couldn’t find any annuity items
      </label>
    </div>
    <div *ngIf="addonList?.length && loadContent">
      <div class="table-header-allign addaddon-table">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="align-left" style="width: 25%">STOCK CODE</th>
              <th scope="col" class="align-left" style="width: 25%">DESCRIPTION</th>
              <th scope="col" class="align-right" style="width: 10%">PRICE</th>
              <th scope="col" class="align-right" style="width: 10%">RRP</th>
              <th scope="col" class="align-center" style="width: 10%">QTY</th>
              <th scope="col" class="align-center" style="width: 10%">QTY TO ADD</th>
              <th scope="col" class="align-center" style="width: 10%"></th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="child-body addaddon-table">
        <table class="table">
          <thead hidden="true">
            <tr>
              <th scope="col" class="align-left" style="width: 25%">STOCK CODE</th>
              <th scope="col" class="align-left" style="width: 35%">DESCRIPTION</th>
              <th scope="col" class="align-right" style="width: 10%">PRICE</th>             
              <th scope="col" class="align-center" style="width: 10%">QTY</th>
              <th scope="col" class="align-center" style="width: 10%">QTY TO ADD</th>
              <th scope="col" class="align-center" style="width: 10%"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let annuityItem of addonListFilter">
              <td style="width: 25%">
                <span class="description-popup">{{annuityItem?.stockCode}}</span>
              </td>
              <td style="width: 25%">
                <span class="description-popup">{{annuityItem?.description}}</span>
              </td>
              <td style="width: 10%;position: relative;vertical-align: middle;text-align: right;" class="align-right">{{annuityItem?.itemPrice}}
                <span *ngIf="annuityItem?.billingFrequency == '1'">/mth</span>
                <span *ngIf="annuityItem?.billingFrequency == 'Y'">/yr</span>
                <span *ngIf="annuityItem?.billingFrequency == 'T'">/3 yr</span>
              </td>
              <td style="width: 10%;position: relative;vertical-align: middle;text-align: right;" class="align-right">
                {{annuityItem?.itemRRPrice}}
                <span *ngIf="annuityItem?.billingFrequency == '1'">/mth</span>
                <span *ngIf="annuityItem?.billingFrequency == 'Y'">/yr</span>
                <span *ngIf="annuityItem?.billingFrequency == 'T'">/3 yr</span>
            </td>
              <td style="width: 10%;position: relative;vertical-align: middle;" class="align-center">
                <span>{{ getItemFromList(annuityItem.stockCode)?.quantity || 0 }}</span>
              </td>
              <td style="width: 10%;position: relative;vertical-align: middle;" class="align-center">
                <input class="align-center align-top input-wrapper input-wrapper-small" [disabled]="annuityItem.disableQty" [(ngModel)]="annuityItem.quantity"
                  type="text">
                <mat-icon matSuffix class="editmpnidicon align-top" *ngIf="annuityItem?.minMaxQtyText" placement="bottom"
                  ngbTooltip="{{annuityItem?.minMaxQtyText}}" container="body">info</mat-icon>
              </td>
              <td style="width: 10%;vertical-align: middle;" class="align-center" mat-dialog-actions>
                <button id="{{annuityItem?.stockCode}}" class="button button-red button-mid confirmbutton"
                  *ngIf="!annuityItem?.isExisting" (click)="AddAddon(annuityItem)">Add item</button>
                <button id="{{annuityItem?.stockCode}}" class="button button-red button-mid confirmbutton"
                  *ngIf="annuityItem?.isExisting" (click)="AddAddon(annuityItem)">Update</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="button-center">
        <button *ngIf="addonList?.length && loadContent" class="button button-red button-large" (click)="finishAddAddon()">Continue</button>
      </div>
    </div>
  </div>
</div>
